import { useEffect, useRef, useState } from "react";
import { userServices } from "../APIServices/UserData/userServices";
import {
  Button,
  Col,
  Collapse,
  Container,
  ListGroup,
  Row,
} from "react-bootstrap";
import {
  RiArrowDownWideLine,
  RiArrowRightWideFill,
  RiProfileLine,
} from "react-icons/ri";
import Sidebar from "./Sidebar";
import SecureScan from "./SecureScan/SecureScan";
import SplitPane from "react-split-pane";
import ToolManagement from "./ToolManagement/ToolManagement";
import MemberManagement from "./MemberManagement/MemberManagement";
import InvitationManagement from "./InvitationManagement/InvitationManagement";
import ItemManagement from "./ItemManagement/ItemManagement";
import { GoGear } from "react-icons/go";
import { LuLogOut } from "react-icons/lu";
import ManageAccount from "./Profile/ManageAccount/ManageAccount";
import AccountSettings from "./Profile/AccountSettings/AccountSettings";
import { groupServices } from "../APIServices/PasswordManagement/groupServices";
import { BsShieldLock } from "react-icons/bs";
import { superAdminMetaServices } from "../APIServices/MetaManagement/superAdminMetaServices";
import { authServices } from "../APIServices/UserData/authServices";
import { useApp } from "../APIHelpers/AppContext";
import InvitationForMe from "./InvitationManagement/InvitationForMe";
import { accountServices } from "../APIServices/PasswordManagement/accountServices";

const Dashboard = () => {
  const {
    auth,
    getCurrectLoginUser,
    currentUserData,
    getSinglePlateformSettings,
    plateformSettings,
    isDark,
    getOrganizations,
    organizationList,
  } = useApp();

  const AppsRef = useRef(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [groupId, setGroupId] = useState("all");
  const [activeItem, setActiveItem] = useState("all");
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [groupData, setGroupData] = useState("");
  const [updator, setUpdator] = useState("");
  const [totalGroupList, setTotalGroupList] = useState([]);
  const [myGroupList, setMyGroupList] = useState([]);
  const [accountList, setAccountList] = useState([]);

  const logout = async () => {
    await authServices.logout(auth);
  };

  const getAccountList = async () => {
    let data = await accountServices.getAccountList(auth, currentUserData?.userId, "active")
    setAccountList(data?.data || [])
  }

  const getMyGroupList = async () => {
    const res = await groupServices.getGroupList(auth, "active");
    setMyGroupList(res?.data || []);
  };

  const getTotalGroupList = async () => {
    const res = await groupServices.getGroupList(auth, "total");
    setTotalGroupList(res?.data || []);
  };

  const getUsedCategoryMetaList = async () => {
    const res = await superAdminMetaServices.getCategoryMetaList(auth, "used");
    setCategoryList(res?.data || []);
  };

  const getSingleGroup = async (groupId) => {
    let data = await groupServices.getSingleGroup(auth, groupId)
    setGroupData(data?.data || [])
  }

  useEffect(() => {
    if (updator.includes("groupList") || !(groupId === "all" || groupId === "bookmark" || groupId === "personal" || groupId === "trash" || groupId === "sharedWithMe" || groupId === "sharedByMe")) {
      getSingleGroup(groupId)
    }
  }, [groupId, updator, auth]);

  useEffect(() => {
    if (!updator || updator.includes("allUpdate") || updator.includes("groupList")) {
      getMyGroupList()
      getTotalGroupList();
    }
    if (!updator || updator.includes("allUpdate") || updator.includes("updateItem")) {
      getUsedCategoryMetaList();
    }
    getCurrectLoginUser();
    if (currentUserData?.roleType === "organization" && (updator.includes("accountList") || !updator)) {
      getAccountList()
    }
  }, [auth, updator]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenProfile(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const renderActiveComponent = () => {
    switch (activeItem) {
      case "manageAccount":
        return (
          <ManageAccount
            isDark={isDark}
            setUpdator={setUpdator}
            currentUserData={currentUserData}
            organizationList={organizationList}
            auth={auth}
          />
        );

      case "manageSettings":
        return (
          <AccountSettings
            isDark={isDark}
            currentUserData={currentUserData}
            setUpdator={setUpdator}
            getSinglePlateformSettings={getSinglePlateformSettings}
            plateformSettings={plateformSettings}
            auth={auth}
          />
        );

      case "secureScan":
        return <SecureScan currentUserData={currentUserData} isDark={isDark} auth={auth} />;

      case "tools":
        return <ToolManagement isDark={isDark} auth={auth} />;

      case "members":
        return <MemberManagement accountList={accountList} currentUserData={currentUserData} isDark={isDark} auth={auth} />;

      case "inviteMembers":
        return <InvitationManagement accountList={accountList} isDark={isDark} auth={auth} />;

      case "invitedMe":
        return <InvitationForMe getOrganizations={getOrganizations} isDark={isDark} auth={auth} />;

      default:
        const isItemManagement =
          activeItem === "all" ||
          activeItem === "bookmark" ||
          activeItem === "personal" ||
          activeItem === "groups" ||
          activeItem === "sharedWithMe" ||
          activeItem === "sharedWithMeGroups" ||
          activeItem === "sharedByMe" ||
          activeItem === "sharedByMeGroups" ||
          activeItem === "archived" ||
          activeItem === "trash" ||
          categoryList?.some((item) => item?.key === activeItem);
        if (isItemManagement && groupId) {
          return (
            <ItemManagement
              auth={auth}
              isDark={isDark}
              activeItem={activeItem}
              groupId={groupId}
              groupList={totalGroupList}
              groupData={groupData}
              setUpdator={setUpdator}
              currentUserData={currentUserData}
              plateformSettings={plateformSettings}
              selectedCategoryId={categoryId}
              getUsedCategoryMetaList={getUsedCategoryMetaList}
              status={activeItem === "all"
                ? "all"
                : activeItem === "sharedByMe"
                  ? "sharedByMe"
                  : activeItem === "sharedWithMe"
                    ? "sharedWithMe"
                    : activeItem === "sharedByMeGroups"
                      ? "sharedByMeGroups"
                      : activeItem === "sharedWithMeGroups"
                        ? "sharedWithMeGroups"
                        : activeItem === "archived"
                          ? "archived"
                          : activeItem === "trash"
                            ? "deleted"
                            : "active"
              }
            />
          );
        }

        return null;
    }
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md={12} className="p-0">
            <SplitPane
              split="vertical"
              minSize={"20%"}
              className="position-relative"
              style={{ height: "100vh" }}
            >
              <div className={!isDark && "bg-light"} style={{ height: "100vh" }}>
                <div className="position-relative mb-2 px-2 pt-2">
                  <Button
                    variant="outline-primary"
                    style={{ fontSize: 14.5 }}
                    className={`w-100 hstack justify-content-between text-start rounded-1 ${activeItem === "manageAccount" ||
                      activeItem === "manageSettings"
                      ? "btn-gradient text-white"
                      : ""
                      }`}
                    title={currentUserData?.name}
                    ref={AppsRef}
                    onClick={() => setOpenProfile(!openProfile)}
                  >
                    <div className="hstack gap-2">
                      {currentUserData?.twoFAStatus && <BsShieldLock style={{ fontSize: 25 }} />}
                      <div className="position-relative">
                        <p className="m-0 fw-bold">{currentUserData?.name}</p>
                        <p className="m-0" style={{ fontSize: 10 }}>{currentUserData?.loginAccountName}</p>
                      </div>
                    </div>
                    {openProfile ? (
                      <RiArrowDownWideLine />
                    ) : (
                      <RiArrowRightWideFill />
                    )}
                  </Button>
                  <Collapse in={openProfile}>
                    <div
                      className="position-absolute shadow-sm"
                      style={{ right: 8.5, zIndex: 99 }}
                    >
                      <ListGroup style={{ fontSize: 13 }}>
                        <ListGroup.Item
                          action
                          className={`hstack gap-2 ${activeItem === "manageAccount" &&
                            "btn-gradient text-white rounded-bottom-0"
                            }`}
                          title="Manage Account"
                          onClick={() => setActiveItem("manageAccount")}
                        >
                          <RiProfileLine /> Manage Account
                        </ListGroup.Item>
                        <ListGroup.Item
                          action
                          className={`hstack gap-2 ${activeItem === "manageSettings" &&
                            "btn-gradient text-white rounded-0"
                            }`}
                          title="Manage Settings"
                          onClick={() => setActiveItem("manageSettings")}
                        >
                          <GoGear /> Manage Settings
                        </ListGroup.Item>
                        <ListGroup.Item
                          action
                          className="hstack gap-2 text-danger"
                          title="Sign Out"
                          onClick={logout}
                        >
                          <LuLogOut /> Sign Out
                        </ListGroup.Item>
                      </ListGroup>
                    </div>
                  </Collapse>
                </div>
                <Sidebar
                  auth={auth}
                  isDark={isDark}
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                  setGroupId={setGroupId}
                  groupId={groupId}
                  groupList={myGroupList}
                  groupData={groupData}
                  categoryList={categoryList}
                  setCategoryId={setCategoryId}
                  setUpdator={setUpdator}
                  plateformSettings={plateformSettings}
                  currentUserData={currentUserData}
                />
              </div>
              {renderActiveComponent()}
            </SplitPane>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Dashboard;
